import fetchExpresso from 'utility/fetchExpresso';

export async function getBundles(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/bundles`);

    if (response.status !== 200) {
        throw new Error('Unable to load bundles');
    }

    return response.json();
}

export async function updateBundleSort(eventId, sort) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/bundles/sort`, {
        method: 'PUT',
        body: { sort },
    });

    if (response.status !== 200) {
        throw new Error('Unable to change order');
    }
}
